
import { defineComponent, watch, ref } from "vue";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "BreadCrumb",
  setup() {
    const route = useRoute();
    const currRoute = ref<{ name: string; path: string }[]>([]);
    const currPath = ref<{ name: string; path: string }>({
      path: route.path,
      name: route.name as string,
    });
    watch(
      () => route.path,
      () => {
        // if (!currRoute.value.length) {
        //   currRoute.value.push({ name: route.name as string, path: route.path });
        // } else {
        //   currRoute.value.forEach((item) => {
        //     if (item.path.indexOf(route.path)) {
        //       currRoute.value.push({ name: route.name as string, path: route.path });
        //     }
        //   });
        // }
        if (route.path != "/home") {
          currPath.value.name = route.name as string;
          currPath.value.path = route.path;
        } else {
          currPath.value.name = "";
          currPath.value.path = "";
        }
      }
    );
    return { currPath };
  },
});
